// src/components/Sidebar/Sidebar.js
import React, { useState, useEffect } from 'react';
import './Sidebar.css';
import { useCountry } from '../../contexts/CountryContext';
import config from '../../config' ; // Adjust the import path as necessary

const Sidebar = ({ onFilterChange,projectno }) => {
  const { selectedCountry,countryName,availableWaves, setAvailableWaves,availableBrands, setAvailableBrands,availableCities, setAvailableCities,filters, setFilters,handleFilterChange,globalFilter, setGlobalFilter,availableCats, setAvailableCat } = useCountry();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Ensure filters have proper defaults
  const safeFilters = {
    brands:  filters.brands || [],
    city:  filters.city || [],
    wave: filters?.wave || '',
    cat: filters?.cat || '',
    demographic: filters?.demographic || ''
  };
  // Fetch filter values whenever selectedCountry changes
  useEffect(() => {
    const fetchCatFilterValues = async () => {
      // Don't fetch if no country is selected
      if (!selectedCountry) {
        setAvailableBrands([]);
        return;
      }

      try {
        setLoading(true);
        const baseUrl = `${config.API_BASE_URL}`;
        
        // Build query parameters correctly
        const params = new URLSearchParams();
        if (selectedCountry && selectedCountry !== 'All') {
          params.append('country', countryName);
          
        }
        params.append('category', globalFilter);
        params.append('project', projectno);
      if (projectno== '2') {
      params.append('cats', filters.cat);}
      
        const queryString = params.toString();
        const urlSuffix = queryString ? `?${queryString}` : '';
        // Fetch unique brands for the selected country
        const brandsResponse = await fetch(`${baseUrl}/api/unique-brands${urlSuffix}`);
        const brandsData = await brandsResponse.json();
        
        
        if (brandsResponse.ok) {
          setAvailableBrands(brandsData.brands || []);
          setError(null);
          //setFilters({brands:brandsData.brands|| [],cities:citiesData.cities|| [],wave:'',demographic:''});
        } else {
          throw new Error('Failed to fetch filter values');
        }
      } catch (err) {
        setError(err.message);
        console.error('Error fetching filter values:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchCatFilterValues();
  }, [filters.cat]); // Re-fetch when selectedCountry from context changes

  // Fetch filter values whenever selectedCountry changes
  useEffect(() => {
    const fetchFilterValues = async () => {
      // Don't fetch if no country is selected
      if (!selectedCountry) {
        setAvailableBrands([]);
        setAvailableCities([]);
        setAvailableWaves([]);
        setAvailableCat([]);
        return;
      }

      try {
        setLoading(true);
        const baseUrl = `${config.API_BASE_URL}`;
        
        // Build query parameters correctly
        const params = new URLSearchParams();
        if (selectedCountry && selectedCountry !== 'All') {
          params.append('country', countryName);
          
        }
        params.append('category', globalFilter);
        params.append('project', projectno);
      if (projectno== '2') {
      params.append('cats', filters.cat);}
        const queryString = params.toString();
        const urlSuffix = queryString ? `?${queryString}` : '';
      
        // Fetch unique brands for the selected country
        const brandsResponse = await fetch(`${baseUrl}/api/unique-brands${urlSuffix}`);
        const brandsData = await brandsResponse.json();
        
        // Fetch unique cities for the selected country
        const citiesResponse = await fetch(`${baseUrl}/api/unique-cities${urlSuffix}`);
        const citiesData = await citiesResponse.json();
        
        // Fetch unique waves for the selected country
        const wavesResponse = await fetch(`${baseUrl}/api/unique-waves${urlSuffix}`);
        const wavesData = await wavesResponse.json();
        // Fetch unique waves for the selected country
        if (projectno== '2') {
        const catResponse = await fetch(`${baseUrl}/api/unique-cat${urlSuffix}`);
        const catData = await catResponse.json();
        if (catResponse.ok) {  
          setAvailableCat(catData.cats || []);
      }}
        if (brandsResponse.ok && citiesResponse.ok && wavesResponse.ok) {

          setAvailableBrands(brandsData.brands || []);
          setAvailableCities(citiesData.cities || []);
          setAvailableWaves(wavesData.waves || []);
          
          setError(null);
          //setFilters({brands:brandsData.brands|| [],cities:citiesData.cities|| [],wave:'',demographic:''});
        } else {
          throw new Error('Failed to fetch filter values');
        }
      } catch (err) {
        setError(err.message);
        console.error('Error fetching filter values:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchFilterValues();
  }, [selectedCountry,globalFilter]); // Re-fetch when selectedCountry from context changes

  const handleBrandToggle = (brand) => {
    const newBrands = safeFilters.brands.includes(brand)
      ? safeFilters.brands.filter(b => b !== brand)
      : [...safeFilters.brands, brand];
    
    handleFilterChange({ ...safeFilters, brands: newBrands });
  };

  const handleCityToggle = (city) => {
  // For radio buttons, set the city directly (single selection)
  const newCity = safeFilters.city === city ? '' : city;
  handleFilterChange({ ...safeFilters, city: newCity });
};
  // const handleCityToggle = (city) => {
  //   const newCities = safeFilters.city.includes(city)
  //     ? safeFilters.city.filter(c => c !== city)
  //     : [...safeFilters.city, city];
  //   handleFilterChange({ ...safeFilters, city: newCities });
  // };

  const handleWaveChange = (wave) => {
    handleFilterChange({ ...safeFilters, wave });
  };
const handleCatChange = (cat) => {
    handleFilterChange({ ...safeFilters, cat });
  };
  
  const handleDemographicChange = (demographic) => {
    onFilterChange({ ...safeFilters, demographic });
  };

  if (loading) {
    return (
      <div className="sidebar">
        <h3>Filters</h3>
        <p>Loading filters for {selectedCountry}...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="sidebar">
        <h3>Filters</h3>
        <p className="error">Error loading filters: {error}</p>
      </div>
    );
  }

  return (
    <div className="sidebar">
      <h3>Filters</h3>
      
      <div className="filter-section">
        <h4>Brands</h4>
        {availableBrands.length > 0 ? (
          availableBrands.map(brand => (
            <label key={brand} className="filter-checkbox">
              <input
                type="checkbox"
                checked={safeFilters.brands.includes(brand)}
                onChange={() => handleBrandToggle(brand)}
                disabled={!selectedCountry}
              />
              {brand}
            </label>
          ))
        ) : (
          <p>{selectedCountry ? 'No brands available' : 'Select a country first'}</p>
        )}
      </div>

{availableCities && availableCities.length>1 && <div className="filter-section">
  <h4>City</h4>
  <select 
    value={safeFilters.city || 'All'} 
    onChange={(e) => handleCityToggle(e.target.value)}
    className="filter-select"
    disabled={!selectedCountry || availableCities.length === 0}
  >
    
    {availableCities.map(city => (
      <option key={city} value={city}>
        {city}
      </option>
    ))}
  </select>
  {availableCities.length === 0 && selectedCountry && (
    <p className="no-cities-message">No cities available for {selectedCountry}</p>
  )}
</div>}

      <div className="filter-section">
        <h4>Wave</h4>
        <select 
          value={safeFilters.wave} 
          onChange={(e) => handleWaveChange(e.target.value)}
          className="filter-select"
          disabled={!selectedCountry}
        >
          
          {availableWaves.map(wave => (
            <option key={wave} value={wave}>
              {`${wave}`}
            </option>
          ))}
        </select>
      </div>
      {availableCats && availableCats.length>2 && projectno=='2' && <div className="filter-section">
        <h4>Category</h4>
        <select 
          value={safeFilters.cat} 
          onChange={(e) => handleCatChange(e.target.value)}
          className="filter-select"
          disabled={!selectedCountry}
        >
          
          {availableCats.map(cat => (
            <option key={cat} value={cat}>
              {`${cat}`}
            </option>
          ))}
        </select>
      </div>}
      {/* <div className="filter-section">
        <h4>Demographic</h4>
        <select 
          value={safeFilters.demographic} 
          onChange={(e) => handleDemographicChange(e.target.value)}
          className="filter-select"
          disabled={!selectedCountry}
        >
          <option value="">All Demographics</option>
          <option value="Age 18-24">Age 18-24</option>
          <option value="Age 25-34">Age 25-34</option>
          <option value="Age 35-44">Age 35-44</option>
          <option value="Age 45+">Age 45+</option>
        </select>
      </div> */}

    </div>
  );
};

export default Sidebar;